var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#9c2e85"},React.createElement("path",{"d":"M59.7 40.6l-6.5 8-18-22.3zM26.8 78.2c-2.1 0-3.4-1.9-3.4-5v-46c0-1.5.3-5 3.3-5 .9 0 2 .4 3.2 1l.2.1c0 .1.1.2.1.3l21.6 26.6-21.5 26.6c-.1.1-.1.2-.2.3l-.1.1c-1.2.7-2.3 1-3.2 1zM53.2 51.9l6.5 8-24.6 14.3zM70.7 54.2l-7.8 4.5-7-8.6 7-8.6 7.9 4.6c1.9 1.1 2.9 2.5 2.9 3.9 0 1.6-1.1 3.1-3 4.2z"})));
}

PlayIcon.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
